export const VIDEO_MEDIAFILE_EXTENSIONS = ['mp4'];

export const videoMedifileExtenisonsSet = new Set(VIDEO_MEDIAFILE_EXTENSIONS);
